import { Text } from '@mantine/core';
import type { PlantKiln } from '../../types/entities';
import classes from './KilnChip.module.css';

interface KilnChipProps {
  kiln: PlantKiln;
}

/**
 * Ein Ofen-Chip in der Werkszeile des Unternehmensdetails (Sketch 008 `.kiln-chip`, UI-SPEC
 * Punkt 6). Die Uebersicht zeigt nur aktive Oefen (Filter in `CompanyDetail.PlantJumpRow`) --
 * damit entfaellt die frueher zweite Chip-Form fuer stillgelegte Oefen samt Statuspunkt: wo
 * ohnehin nur ein Zustand vorkommt, unterscheidet ein Punkt nichts.
 */
export function KilnChip({ kiln }: KilnChipProps) {
  return <span className={classes.chip}>{kiln.name}</span>;
}

/**
 * Werk ohne Ofen: ruhiger Normalfall (24 von 54 Werken der Kundenliste), kein Orange, kein Rot --
 * exakt `.none` aus Sketch 008 (UI-SPEC Copywriting-Tabelle).
 */
export function NoKilnChip() {
  return (
    <Text span size="xs" c="vdzGray.5" fs="italic">
      kein Drehofen
    </Text>
  );
}
